/**
 * IB Pix transactional limits via MobileService
 * `GET /v1/ib/pix/limits` → BaaS `/v1/pix/accounts/{id}/limits/available`
 */

import api from "./api";

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const mapLimitItem = (raw = {}) => {
  const typeCode = raw.type_code || raw.typeCode || raw.id || "";
  const type = toNumber(raw.type);
  return {
    id: raw.id || typeCode || `type_${type}`,
    type,
    typeCode,
    type_code: typeCode,
    label: raw.label || typeCode || "Limite",
    description: raw.description || "",
    period: raw.period === "noturno" ? "noturno" : "diurno",
    periodCode: toNumber(raw.period_code ?? raw.periodCode),
    periodHourStart: toNumber(raw.period_hour_start ?? raw.periodHourStart),
    periodHourEnd: toNumber(raw.period_hour_end ?? raw.periodHourEnd),
    periodHours: raw.period_hours || raw.periodHours || "",
    usedCents: Math.round(toNumber(raw.used_cents ?? raw.usedCents)),
    totalCents: Math.round(toNumber(raw.total_cents ?? raw.totalCents)),
    availableCents: Math.round(toNumber(raw.available_cents ?? raw.availableCents)),
    perOperationCents: Math.round(
      toNumber(raw.per_operation_cents ?? raw.perOperationCents),
    ),
    percentUsed: toNumber(raw.percent_used ?? raw.percentUsed),
    sourceScope: raw.source_scope || raw.sourceScope || null,
    activeNow: Boolean(raw.active_now ?? raw.activeNow),
    comingSoon: Boolean(raw.coming_soon ?? raw.comingSoon),
  };
};
export const getPixTransactionalLimits = async () => {
  const { data } = await api.get("/v1/ib/pix/limits");
  const root = data?.data ?? data;
  const items = Array.isArray(root?.items)
    ? root.items
    : Array.isArray(root)
      ? root
      : [];

  return {
    accountId: root?.account_id || root?.accountId || null,
    items: items.map(mapLimitItem),
    total: toNumber(root?.total ?? items.length),
    providerSplitCapCents: Math.round(
      toNumber(root?.provider_split_cap_cents ?? root?.providerSplitCapCents),
    ),
    spiMaxPerOperationCents: Math.round(
      toNumber(root?.spi_max_per_operation_cents ?? root?.spiMaxPerOperationCents),
    ),
    activeProviderPeriodLabel:
      root?.active_provider_period_label ?? root?.activeProviderPeriodLabel ?? null,
  };
};
